import styled from 'styled-components/macro';
import SimpleButton from 'styled/Buttons/SimpleButton';

const Button = styled(SimpleButton)`
  position: absolute;
  top: 16px;
  right: 16px;
  border-radius: 50%;
  opacity: 0.6;
  transition: opacity 0.15s ease-out;

  &:hover {
    opacity: 1;
  }
`;

export default Button;
